<div class="overview-menu-field">
	@switch (header().headerDisplayType) {
		@case(headerDisplayTypes.icon) {
			@if(header().icon){
					<ogs-m3-icon [icon]="header().icon!"/>
			}
		}
		@case(headerDisplayTypes.string){
			@if(header().translationInfo){
					<span class="mat-body-small">{{header().translationInfo!.defaultText | translate : header().translationInfo!.token : header().translationInfo!.scope}}</span>
			}
		}
	}
	<section class="overview-menu-field__options">
		<!--eslint-disable-next-line @angular-template/prefer-self-closing-tags-->
		<ng-container [ngTemplateOutlet]="visibilityButton"></ng-container>
		<ng-container [ngTemplateOutlet]="fixedButton" />
	</section>
</div>


<ng-template #visibilityButton>
	<button class="overview-menu-field__option" mat-icon-button (click)="onVisibilityClick()">
		@if(header().options.isVisible){
			<ogs-m3-icon prefix="fal" icon="eye"/>
		}
		@else{
			<ogs-m3-icon prefix="fal" icon="eye-slash"/>
		}
	</button>
</ng-template>

<ng-template #fixedButton>
	@if(header().options.isVisible) {
		<button mat-icon-button (click)="onFixedClick()" class="overview-menu-field__option">
			@if(header().options.isFixed){
				<ogs-m3-icon prefix="fal" icon="xmark"/>
			}
			@else{
				<ogs-m3-icon prefix="fal" icon="thumbtack"/>
			}
		</button>
	}
	@else {
		<button mat-icon-button (click)="onFixedClick()" disabled class="overview-menu-field__option overview-menu-field__button--disabled">
			<ogs-m3-icon prefix="fal" icon="thumbtack"/>
		</button>
	}
</ng-template>